module.exports = __webpack_public_path__ + "img/walking.27f1ba22.svg";